import { useQuery } from 'react-query';

import { Advertisement } from '../../../types/Advertisement';
import Api from '../../api/api';

export const getAdvertisement = async (id: string): Promise<Advertisement> => {
  const [response, bodyOrError] = await Api.get(`advertisement/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetAdvertisement = (id: string) =>
  useQuery(['getAdvertisement', id], () => getAdvertisement(id), {
    enabled: !!id,
  });
